export const ugovor_o_preuzimanju_duga = {
  templateId: 23,
  category: 2,
  templateTitle: "Ugovor o preuzimanju duga",
  templateDescription: `Ugovor o preuzimanju duga je trostrani ugovor (cesija je dvostrani) u kojemu dolazi do promjene dužnika, na način da umjesto postojećeg dužnika dug preuzima novi dužnik, uz pristanak vjerovnika. Za točniji odabir načina reguliranja međusobnih odnosa predlažemo da koristite <a target="_blank" href="http://solucio-debit.com">Solucio Debit app</a>.`,
  description: `
    <h5>OPIS I SVRHA DOKUMENTA</h5>
    <p>Ugovor o preuzimanju duga je <strong>trostrani ugovor </strong>(cesija je dvostrani) u kojemu dolazi do promjene dužnika, na način da umjesto postojećeg dužnika dug preuzima novi dužnik (preuzimatelj duga), <strong>uz pristanak vjerovnika.</strong></p>
    <p>Ukoliko želite provjeriti hoće li ova vrsta ugovora biti ispravan odabir za međusobno reguliranje odnosa, predlažemo korištenje aplikacije <a target="_blank" href="http://solucio-debit.com">Solucio Debit app</a> koja će brzo i točno dati rješenje za vašu situaciju. </p>
    <p>Dakle, kod ugovora o preuzimanju duga radi se o promjeni dužnika u postojećem ugovornom odnosu (umjesto postojećeg, vjerovniku je dužnik nova osoba), dok vjerovnik ostaje isti.</p>
    <p><strong>Preuzimanje duga valja razlikovati od pristupanja dugu i preuzimanja ispunjenja.</strong></p>
    <p><strong>Ugovorom o pristupanju dugu, pristupatelj dugu se obvezuje vjerovniku da će ispuniti dugovanje dužnika, ukoliko dužnik to ne učini.</strong></p>
    <p><strong>Ugovorom o preuzimanju ispunjenja, </strong>treća osoba (preuzimatelj) se obvezuje dužniku da će ispuniti njegovu obvezu prema vjerovniku. To je dakle <strong>dvostrani pravni posao</strong>, o kojemu se vjerovnik ne obavješćuje, niti daje na isti pristanak.</p>
    <p>Bitno je naglasiti da <strong>sve dok na ugovor o preuzimanju duga, vjerovnik ne da pristanak ili ukoliko odbije dati pristanak, ugovor o preuzimanju duga ima učinak ugovora u preuzimanju ispunjenja.</strong></p>
    <p>Smatra se da je vjerovnik dao svoj pristanak ako je bez ograde primio neko ispunjenje od novog dužnika (preuzimatelja duga), koje je ovaj učinio u svoje ime.</p>
    <p>Također, ako je u vrijeme vjerovnikova pristanka na ugovor o preuzimanju duga, preuzimatelj duga bio prezadužen, a vjerovnik to nije znao niti je morao znati, prijašnji dužnik se ne oslobađa obveze, već ugovor o preuzimanju duga ima učinak ugovora o pristupanju dugu.</p>
    <p><strong>Osim gore navedenih razlika između ugovora o preuzimanju duga, ugovora o pristupanju dugu i ugovora o preuzimanju ispunjenja, vrlo je bitno razlikovati navedene ugovore od ugovora o cesiji. </strong></p>
    <p><strong></strong></p>
    <p><strong>Ugovorne strane mogu svoje međusobne odnose riješiti ugovorom o preuzimanju duga, ali i ugovorom o cesiji odnosno ugovorom o asignaciji, ovisno o ciljevima koje žele postići.</strong></p>
    <p><strong></strong></p>
    <p><strong>Navedene mogućnosti uređenja odnosa izlažu se primjerom u nastavku:</strong></p>
    <p><strong>Pretpostavimo da u trenutnom odnosu A duguje B, B duguje C, pa je tako:</strong></p>
    <p><strong>A dužnik B, </strong></p>
    <p><strong>B je vjerovnik A, a dužnik C.</strong></p>
    <p><strong></strong></p>
    <p>Ugovorne strane mogu svoje međusobne odnose riješiti na sljedeće načine:</p>
    <ol>
      <li>
        <p>Reguliranje međusobnih odnosa kroz cesiju umjesto plaćanja</p>
        <p>B kao cedent (stari vjerovnik) ustupa C (cesionar, novi vjerovnik) svoju tražbinu koju ima prema A (cesus, dužnik), čime podmiruje svoje dugovanje prema C. Sklapanjem ugovora prestaje dugovanje B prema C.</p>
      </li>
      <li>
        <p>Reguliranje međusobnih odnosa kroz cesiju radi ispunjenja (naplaćivanja)</p>
        <p>B kao cedent (stari vjerovnik) ustupa C (cesionar, novi vjerovnik) svoju tražbinu koju ima prema A (cesus, dužnik). Sve međusobne obveze prestaju tek kada A ispuni obvezu prema C, za razliku od cesiju umjesto plaćanja kod koje samim sklapanjem ugovora prestaje dugovanje B prema C.</p>
      </li>
      <li>
        <p>Reguliranje međusobnih odnosa kroz cesiju radi osiguranja</p>
        <p>B kao cedent (stari vjerovnik) ustupa C (cesionaru, novi vjerovnik) svoju tražbinu koju ima prema A (cesus, dužnik), radi osiguranja tražbine C prema B. C je dužan brinuti o naplati ustupljene tražbine, a po naplati višak predati B.</p>
      </li>
      <li>
        <p>Reguliranje međusobnih odnosa kroz preuzimanje duga</p>
        <p>A (kao novi dužnik) preuzima dugovanje B (stari dužnik) prema C (vjerovnik), a kojim preuzimanjem duga se stvara tražbina A prema B koje se potom kompenzira s ranijom protutražbinom B prema A. Obveza B (stari dužnik) prema C više ne postoji između navedenih subjekata, jer je preuzeta ugovorom o preuzimanju duga (A je preuzeo dug od B).</p>
      </li>
      <li>
        <p>Reguliranje međusobnih odnosa kroz asignaciju</p>
        <p>A (kao upućenik - asignat) na temelju upute B (uputitelja - asignanta) prihvaća ovlast da u ime B podmiri obvezu B prema C, a ujedno C (primatelj upute - asignatar) prima ovlast da ispunjenje primi u svoje ime. Za razliku od cesije umjesto plaćanja i preuzimanja duga, kod ugovora o asignaciji, međusobne obveze prestaju tek s ispunjenjem upute (podmirenjem obveze A, primanjem ispunjenja C).</p>
      </li>
    </ol>
    <p><strong>Dakle, isti poslovni odnos između dužnika i vjerovnika može biti reguliran kroz ugovor o cesiji umjesto plaćanja, ugovor o cesiji radi ispunjenja (naplaćivanja), ugovor o cesiji radi osiguranja ili kroz ugovor o preuzimanju duga odnosno kroz ugovor o asignaciji, ovisno o poslovnim interesima i dogovoru ugovornih strana.</strong></p>
    <p><strong></strong></p>

    <p><strong>NAPOMENA: Ovršenik (dužnik) kao poslovni subjekt ne smije  (prema Zakonu o provedbi ovrhe na novčanim sredstvima) sklapati ugovore radi obračunskog plaćanja ako u Jedinstvenom registru računa ima oznaku blokade računa, odnosno zabranu raspolaganja oročenim novčanim sredstvima, ako tim obračunskim plaćanjem kao vjerovnik tražbine (u ovom slučaju, kod preuzimanja duga, zabrana se odnosi na dužnika, a ne na preuzimatelja duga ili vjerovnika) onemogućuje ili izbjegava primitak ispunjenja obveze u novcu. Novčana kazna u slučaju kršenja navedenog može biti do 500.000,00 kn. </strong></p>
   
    <p><strong> Osim toga, sukladno Zakonu o obveznim odnosima takav ugovor je ništetan (ne proizvodi nikakve pravne učinke) jer je protivan prisilnim propisima (Zakon o provedbi ovrhe na novčanim sredstvima). <p></strong>
    <p><strong>Vjerovnik koji je znao za postojeću blokadu računa svojeg dužnika može biti kazneno odgovoran (za kazneno djelo prijevare u
    gospodarskom poslovanju te pomaganju u pogodovanju vjerovnika) ukoliko unatoč izričitoj zabrani ipak sklopi
    ugovor o obračunskom plaćanju u cilju naplate svojeg potraživanja prije drugih
    vjerovnika, koji prema redoslijedu naplate s blokiranog računa dužnika imaju prednost
    pri namirenju, a u tom slučaju i odgovara trećima za nastalu štetu.   <p></strong>
    <p><strong>Dužnik (poslovni subjekt) kojemu je blokiran račun odnosno koji ima oznaku zabranu raspolaganja oročenim novčanim sredstvima ne smije svoje obveze plaćati gotovim novcem, plaćati preko institucije za platni promet niti preko ostalih pružatelja platnih usluga u Republici Hrvatskoj, kao niti plaćati ili primati plaćanja preko računa otvorenog kod pružatelja platnih usluga u inozemstvu, a ne smije niti preusmjeravati novčane i financijske tijekove na drugu osobu niti primati uplate i isplaćivati novčana sredstva na račune drugih osoba.</strong><p>
    <h5>NAJČEŠĆE GREŠKE</h5>
  
        <p><strong>- Sklapanje ugovora o cesiji umjesto ugovora o preuzimanju duga</strong></p>
        <p>Pojašnjenje: cesiju/e (redovita cesija, cesija umjesto ispunjenja/plaćanja, cesija radi ispunjenja, cesija radi osiguranja), kao promjene vjerovnika bitno je razlikovati od promjena na strani dužnika (preuzimanje duga, pristupanje dugu, preuzimanje ispunjenja), a poglavito u odnosu na preuzimanje duga.</p>
        <p>Ugovor o preuzimanju duga je trostrani ugovor (cesija je dvostrani) u kojemu dolazi do promjene dužnika, na način da umjesto postojećeg dužnika dug preuzima novi dužnik, uz pristanak vjerovnika.</p>
        <p>Ukoliko se dužnik dogovori s novim dužnikom da će preuzeti njegov dug prema vjerovniku, tada se zaključuje ugovor o preuzimanju duga, no ukoliko se vjerovnik dogovori s novim vjerovnikom (bez pristanka dužnika) da će mu ustupiti tražbinu (umjesto plaćanja obveza postojećeg vjerovnika prema novom vjerovniku), tada postojeći vjerovnik i novi vjerovnik zaključuju <strong>ugovor o cesiji umjesto plaćanja</strong> kojemu dužnik nije ugovorna strana, nego se o izvršenoj cesiji samo obavješćuje.</p>
        <p>Dakle, isti poslovni odnos između dužnika i vjerovnika može biti reguliran kroz ugovor o cesiji umjesto plaćanja ili kroz ugovor o preuzimanju duga, <strong>no bitno je točno razumjeti i odabrati onaj ugovor koji će predstavljati pravu volju ugovornih strana.</strong></p>
        <p><strong> -Sklapanje ugovora o preuzimanju duga bez predaje odgovarajuće dokumentacije o tražbini</strong></p>
        <p>Pojašnjenje: vrlo je važno da dužnik preda novom dužniku sve isprave (račune, eventualne otpremnice i sl.) koje se odnose na tražbinu kako bi navedene dokumente mogao adekvatno knjižiti i imati u posjedu za potrebe eventualnih sudskih postupaka.</p>
 
    <h5>PRAVNA OSNOVA</h5>
    <p>Zakon o obveznim odnosima.</p>
  `,

  sides: [
    {
      prefix: "DUŽNIK:",
      signature: "Za DUŽNIKA:",
      inputs: [{
        type: "input",
        required: true,
        placeholder: "Poslovni subjekt",
      },
      {
        type: "input",
        required: true,
        placeholder: "Ulica i kućni broj",
      },
      {
        type: "input",
        required: true,
        placeholder: "Mjesto",
      },
      {
        type: "input",
        required: true,
        placeholder: "OIB",
      },
      {
        type: "input",
        placeholder: "Zastupa",
        inSignature: true,
      },
      {
        type: "input",
        placeholder: "Funkcija",
        inSignature: true,
      }],
      delimiter: "i"
    },
    {
      prefix: "\r\nNOVI DUŽNIK:",
      signature: "Za NOVOG DUŽNIKA:",
      inputs: [{
        type: "input",
        required: true,
        placeholder: "Poslovni subjekt",
      },
      {
        type: "input",
        required: true,
        placeholder: "Ulica i kućni broj",
      },
      {
        type: "input",
        required: true,
        placeholder: "Mjesto",
      },
      {
        type: "input",
        required: true,
        placeholder: "OIB",
      },
      {
        type: "input",
        placeholder: "Zastupa",
        inSignature: true,
      },
      {
        type: "input",
        placeholder: "Funkcija",
        inSignature: true,
      }],
      delimiter: "i"
    },
    {
      prefix: "\r\nVJEROVNIK:",
      signature: "Za VJEROVNIKA:",
      inputs: [{
        type: "input",
        required: true,
        placeholder: "Poslovni subjekt",
      },
      {
        type: "input",
        required: true,
        placeholder: "Ulica i kućni broj",
      },
      {
        type: "input",
        required: true,
        placeholder: "Mjesto",
      },
      {
        type: "input",
        required: true,
        placeholder: "OIB",
      },
      {
        type: "input",
        placeholder: "Zastupa",
        inSignature: true,
      },
      {
        type: "input",
        placeholder: "Funkcija",
        inSignature: true,
      }
    ],
    suffix: ","
    }
  ],

  headline: "zaključuju sljedeći",
  title: "UGOVOR O PREUZIMANJU DUGA",

  articles: [


    {
      title: "DUG DUŽNIKA",
      mandatory: true,
      statements: [
      
        {
          type: "input",
          editable: false,
          mandatory: true,
          parts: [
        
            {type: "text", content: "Ugovorne strane suglasno utvrđuju da DUŽNIK ima nepodmirena dugovanja prema VJEROVNIKU u iznosu od"},
            { type: "input", value: "", required: true },
            { type: "text", newline:"true", content: "\r\nUgovorne strane suglasno izjavljuju da je prethodno navedeni iznos dugovanja naveden isključivo u svrhu provedbe ovog Ugovora te da dugovanje DUŽNIKA prema VJEROVNIKU eventualno može biti i veće, stoga se odriču pozivati da iznos dugovanja naveden u ovom Ugovoru predstavlja cjelokupni iznos dugovanja DUŽNIKA prema VJEROVNIKU." },

       
          ],
          }
        ]
      },  
    {
      title: "PREDMET UGOVORA",
      mandatory: true,
      statements: [
        {
          type: "text",
          mandatory: true,
          content: "NOVI DUŽNIK, sklapanjem ovog Ugovora preuzima dužničku poziciju dotadašnjeg DUŽNIKA u opsegu i iznosu određenom ovim Ugovorom, a DUŽNIK se preuzimanjem duga oslobađa obveze prema VJEROVNIKU u iznosu preuzetog duga."
        },
      ]
    },
    {
      title: "OPSEG PREUZIMANJA DUGA",
      mandatory: true,
      statements: [
        {
          type: "choice",
          mandatory: true,
          editable: false,
          choices: [
            {
              parts: [
                { type: "text", content: "Ovim Ugovorom, NOVI DUŽNIK preuzima dugovanje DUŽNIKA prema VJEROVNIKU i to u cjelokupnom iznosu dugovanja navedenog u ovom Ugovoru." }
              ]
            },
            {
              parts: [
                { type: "text", content: "Ovim Ugovorom, NOVI DUŽNIK djelomično preuzima dugovanje DUŽNIKA prema VJEROVNIKU iz ovog Ugovora i to u iznosu od" },
                { type: "input", value: "", help: "Ukoliko želite ugovoriti da Preuzimatelj duga preuzima samo dio dugovanja iz ovog Ugovora, onda odaberite ovu opciju i unesite iznos.", required: true },
              ]
            }
          ],
        }
      ]
    },
 
    {
      title: "ISPRAVE",
      mandatory: true,
      statements: [
        {
          type: "text",
          mandatory: true,
          content: "DUŽNIK se obvezuje NOVOME DUŽNIKU predati sve isprave koje dokazuju postojanje i visinu dugovanja iz ovog Ugovora."
        },
      ]
    },
    {
      title: "PRIJELAZ DUGA S NOVOG DUŽNIKA NA DUŽNIKA",
      mandatory: false,
      statements: [
        {
          type: "text",
          mandatory: true,
          editable: true,
          content: "Ugovorni odnos između DUŽNIKA i VJEROVNIKA prelazi na NOVOG DUŽNIKA i VJEROVNIKA u času kada VJEROVNIK da svoj pristanak.\r\nVJEROVNIK pristaje na preuzimanje duga po ovom Ugovoru potpisom ovog Ugovora, na dan sklapanja istog."
        }
      ]
    },
    {
      title: "MJERODAVNO PRAVO",
      mandatory: false,
      statements: [
        {
          type: "text",
          mandatory: true,
          editable: true,
          content: "Ugovorne strane suglasno utvrđuju da će se na sve odnose koji nisu riješeni ovim Ugovorom primjenjivati odredbe važećih propisa Republike Hrvatske, a primarno odredbe Zakona o obveznim odnosima."
        }
      ]
    },
    {
      title: "NADLEŽNOST",
      mandatory: false,
      statements: [
        {
          type: "choice",
          mandatory: true,
          editable: false,
          choices: [
            {
              parts: [
                { type: "text", content: "Svi sporovi koji proizađu ili budu u vezi s ovim Ugovorom rješavati će se pred stvarno nadležnim sudom prema sjedištu DUŽNIKA." }
              ]
            },
            {
              parts: [
                { type: "text", content: "Svi sporovi koji proizađu ili budu u vezi s ovim Ugovorom rješavati će se pred stvarno nadležnim sudom prema sjedištu NOVOG DUŽNIKA." }
              ]
            },
            {
              parts: [
                { type: "text", content: "Svi sporovi koji proizađu ili budu u vezi s ovim Ugovorom rješavati će se pred stvarno nadležnim sudom u " },
                { type: "input", value: "", help: "Upišite mjesno nadležni sud. Npr. ...sudom u Zagrebu; ...sudom u Splitu i sl..", required: true },
              ]
            }
          ],
        }
      ]
    },
    {
      title: "PRIMJENA UGOVORA",
      mandatory: false,
      statements: [
        {
          type: "text",
          mandatory: true,
          editable: true,
          content: "Ugovor se primjenjuje od trenutka potpisa ugovornih strana."
        }
      ]
    },
    {
      title: 'PRIMJERCI UGOVORA',
      mandatory: false,
      statements: [
          {
              type: 'text',
              required: false,
              mandatory: true,
              editable: true,
              content: 'Ovaj Ugovor sastavljen je u 3 (tri) primjerka, od kojih svaka ugovorna strana zadržava po 1 (jedan) primjerak.',
              value: '',
          }],
    },
  {
    mandatory: true,
    static: true,
    type: 2, // date and place
    statements: [
      {
        type: "input",
        mandatory: true,
        parts: [
          {
            type: "text",
            content: "U"
          },
          {
            type: "input",
            value: "",
            placeholder: "Upišite mjesto.",
            required: true,
          },
          {
            type: "text",
            content: ", dana"
          },
          {
            type: "date",
            value: new Date(),
            required: true
          },
          {
            type: "text",
            content: "godine."
          }
        ]
      },
    ]
  },
    {
      mandatory: true,
      static: true,
      type: 3,  // signatures
      statements: [],
    },
  ],
}; 


// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contracts/23_ugovor_o_preuzimanju_duga.ts